import {get_response} from "../helper/request";
import {SearchAlertUserConstant} from "../redux_constants/search.user.constant";
import {UserActions} from '../redux_constants/users.constant';
import {searchFailed, searchInitiated} from "./search.case.action";

export const changePage = (pageNumber) => ({
    type: SearchAlertUserConstant.USER_CHANGE_PAGE,
    pageNumber: pageNumber
})

export const changeTotalNumberOfPages = (numPages) => ({
    type: UserActions.CHANGE_TOTAL_NUMBER_OF_PAGES_USER,
    numPages: numPages
})

export const changeTotal = (total) => ({
    type: UserActions.CHANGE_TOTAL_USER,
    total: total
})

export const allUsersLoadingSuccess = (success) => (dispatch) => {
    dispatch({
        type: UserActions.ALL_USERS_UPDATE_SUCCESS,
        response: success
    });
    dispatch(changeTotalNumberOfPages(success.data.total_pages));
    dispatch(changePage(success.data.page_number));
    dispatch(changeTotal(success.data.count));
}

export const loadUsers = (partsOfUrl) => dispatch => {
    dispatch(searchInitiated());

    var encodedUrl = urlEncoder(partsOfUrl);
    let url = `/api/paginated_users/` + encodedUrl;
    get_response(url, true)
        .then(response => {
            if (response.status === 200) {
                dispatch(allUsersLoadingSuccess(response));
                dispatch({
                    type: SearchAlertUserConstant.USER_UPDATE_URL_STATE,
                    urlState: {
                        isFetching: false,
                        page: response.data.page_number,
                        numPages: response.data.total_pages,
                        total: response.data.count
                    },
                });
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
        })
}


export const loadGroups = () => dispatch => {
    let url = `/api/group/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: UserActions.UPDATE_GROUPS,
                    groups: response.data,
                });
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
        })
}

export const updateGroups = (newGroups) => dispatch => {
    if (!Array.isArray(newGroups)) newGroups = [newGroups];
    dispatch({
        type: UserActions.ADD_GROUPS,
        groups: newGroups,
    });
}

export const loadOrganisations = () => dispatch => {
    let url = `/api/organisation/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: UserActions.ADD_ORGANISATIONS,
                    organisations: response.data,
                });
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
        })
}

export const updateOrganisations = (newOrganisations) => dispatch => {
    if (!Array.isArray(newOrganisations)) newOrganisations = [newOrganisations];
    dispatch({
        type: UserActions.UPDATE_ORGANISATIONS,
        organisations: newOrganisations,
    });
}

export const deleteOrganisation = (organisationName) => (dispatch) => {
    dispatch({
        type: UserActions.DELETE_ORGANISATION,
        organisationName
    });
};

export const urlEncoder = (partsOfUrl) => {
    var encodedUrl = '?';
    if (partsOfUrl === undefined) {
        return encodedUrl;
    }
    if ('search' in partsOfUrl) {
        encodedUrl += partsOfUrl.search !== '' ? '&search=' + partsOfUrl.search : '';
    }
    if ('page' in partsOfUrl) {
        encodedUrl += '&page=' + partsOfUrl.page;
    }
    return encodedUrl;
}
